import React from "react";

export default class ErrorBoundary extends React.Component {

    state = {
        error: false
    }

    componentDidCatch(error, errorInfo) {
        this.setState({error: true})
    }

    render() {
        const {error} = this.state;
        return error ? <div className="billboard">
            <h1>An error has occured!</h1>
        </div> : this.props.children;
    }
}